import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Go to DeWiser and know more
        </p>
        <a
          className="App-link"
          href="https://www.dewiser.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          DeWiser
        </a>
      </header>
    </div>
  );
}

export default App;
